import { GlModal, GlSearchBoxByType } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import ScrollScrim from '~/vue_shared/components/scroll_scrim/scroll_scrim.vue';
import { GLOBAL_SEARCH_MODAL_CLASS } from '~/super_sidebar/components/global_search/constants';
import DashboardFrequentProjects from './dashboard_frequent_projects.vue?vue3';
import DashboardFrequentGroups from './dashboard_frequent_groups.vue?vue3';
import DashboardSearchResults from './dashboard_search_results.vue?vue3';
export const LINK_TO_DASHBOARD_MODAL_ID = 'link-to-dashboard-modal';
export default {
    name: 'LinkToDashboardModal',
    components: {
        GlModal,
        GlSearchBoxByType,
        ScrollScrim,
        DashboardFrequentProjects,
        DashboardFrequentGroups,
        DashboardSearchResults
    },
    props: {
        dashboardName: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            searchText: ''
        };
    },
    computed: {
        showDefaultItems () {
            return !this.searchText;
        }
    },
    methods: {
        onModalHidden () {
            this.searchText = '';
        }
    },
    LINK_TO_DASHBOARD_MODAL_ID,
    GLOBAL_SEARCH_MODAL_CLASS,
    i18n: {
        title: s__('Dashboards|Select a group or project for this analytics dashboard'),
        placeholder: s__('Dashboards|Search for a project or group...')
    }
};
